import React from 'react'
import { Field } from 'formik'
import { Checkbox, InputField } from 'components'
import { FormDamage } from 'pages/damage_reports/DamageReportForm/types'
import classes from './DamagePickers.module.scss'
import { useTranslation } from 'react-i18next'

interface DamagePickersProps {
  prefix: string
  values: FormDamage
}

export const DamagePickers: React.FunctionComponent<DamagePickersProps> = ({
  prefix,
  values,
}) => {
  const { t } = useTranslation()
  return (
    <table className={classes.damagePickers}>
      <tbody>
        <tr>
          <td>
            <Field
              component={Checkbox}
              id={`${prefix}-bumperFront`}
              name={`${prefix}.bumperFront`}
              label={t(
                'pages.damageReports.damageReportForm.damageFields.damagePicker.bumperFront'
              )}
            />
          </td>
        </tr>

        <tr>
          <td>
            <Field
              component={Checkbox}
              id={`${prefix}-engineCooler`}
              name={`${prefix}.engineCooler`}
              label={t(
                'pages.damageReports.damageReportForm.damageFields.damagePicker.engineCooler'
              )}
            />
          </td>
        </tr>

        <tr>
          <td>
            <Field
              component={Checkbox}
              id={`${prefix}-engineHood`}
              name={`${prefix}.engineHood`}
              label={t(
                'pages.damageReports.damageReportForm.damageFields.damagePicker.engineHood'
              )}
            />
          </td>
        </tr>

        <tr>
          <th scope="row" className={classes.checkboxLabel}>
            {t(
              'pages.damageReports.damageReportForm.damageFields.damagePicker.frontFender'
            )}
          </th>

          <td>
            <Field
              component={Checkbox}
              id={`${prefix}-fenderLeft`}
              name={`${prefix}.fenderLeft`}
              label={t(
                'pages.damageReports.damageReportForm.damageFields.damagePicker.left'
              )}
              inline
            />
          </td>
          <td>
            <Field
              component={Checkbox}
              id={`${prefix}-fenderRight`}
              name={`${prefix}.fenderRight`}
              label={t(
                'pages.damageReports.damageReportForm.damageFields.damagePicker.right'
              )}
              inline
            />
          </td>
        </tr>

        <tr>
          <th scope="row" className={classes.checkboxLabel}>
            {t(
              'pages.damageReports.damageReportForm.damageFields.damagePicker.frontDoor'
            )}
          </th>
          <td>
            <Field
              component={Checkbox}
              id={`${prefix}-frontDoorLeft`}
              name={`${prefix}.frontDoorLeft`}
              label={t(
                'pages.damageReports.damageReportForm.damageFields.damagePicker.left'
              )}
              inline
            />
          </td>
          <td>
            <Field
              component={Checkbox}
              id={`${prefix}-frontDoorRight`}
              name={`${prefix}.frontDoorRight`}
              label={t(
                'pages.damageReports.damageReportForm.damageFields.damagePicker.right'
              )}
              inline
            />
          </td>
        </tr>

        <tr>
          <th scope="row" className={classes.checkboxLabel}>
            {t(
              'pages.damageReports.damageReportForm.damageFields.damagePicker.sideDoor'
            )}
          </th>
          <td>
            <Field
              component={Checkbox}
              id={`${prefix}-sidePanelOrDoorLeft`}
              name={`${prefix}.sidePanelOrDoorLeft`}
              label={t(
                'pages.damageReports.damageReportForm.damageFields.damagePicker.left'
              )}
              inline
            />
          </td>
          <td>
            <Field
              component={Checkbox}
              id={`${prefix}-sidePanelOrDoorRight`}
              name={`${prefix}.sidePanelOrDoorRight`}
              label={t(
                'pages.damageReports.damageReportForm.damageFields.damagePicker.right'
              )}
              inline
            />
          </td>
        </tr>

        <tr>
          <td>
            <Field
              component={Checkbox}
              id={`${prefix}-tailgate`}
              name={`${prefix}.tailgate`}
              label={t(
                'pages.damageReports.damageReportForm.damageFields.damagePicker.tailgate'
              )}
            />
          </td>
        </tr>

        <tr>
          <td>
            <Field
              component={Checkbox}
              id={`${prefix}-bumperBack`}
              name={`${prefix}.bumperBack`}
              label={t(
                'pages.damageReports.damageReportForm.damageFields.damagePicker.bumperBack'
              )}
            />
          </td>
        </tr>

        <tr>
          <th scope="row" className={classes.checkboxLabel}>
            {t(
              'pages.damageReports.damageReportForm.damageFields.damagePicker.tiresFront'
            )}
          </th>
          <td>
            <Field
              component={Checkbox}
              id={`${prefix}-tires-frontLeft`}
              name={`${prefix}.tires.frontLeft`}
              label={t(
                'pages.damageReports.damageReportForm.damageFields.damagePicker.left'
              )}
              inline
            />
          </td>
          <td>
            <Field
              component={Checkbox}
              id={`${prefix}-tires-frontRight`}
              name={`${prefix}.tires.frontRight`}
              label={t(
                'pages.damageReports.damageReportForm.damageFields.damagePicker.right'
              )}
              inline
            />
          </td>
        </tr>

        <tr>
          <th scope="row" className={classes.checkboxLabel}>
            {t(
              'pages.damageReports.damageReportForm.damageFields.damagePicker.tiresBack'
            )}
          </th>
          <td>
            <Field
              component={Checkbox}
              id={`${prefix}-tires-rearLeft`}
              name={`${prefix}.tires.rearLeft`}
              label={t(
                'pages.damageReports.damageReportForm.damageFields.damagePicker.left'
              )}
              inline
            />
          </td>
          <td>
            <Field
              component={Checkbox}
              id={`${prefix}-tires-rearRight`}
              name={`${prefix}.tires.rearRight`}
              label={t(
                'pages.damageReports.damageReportForm.damageFields.damagePicker.right'
              )}
              inline
            />
          </td>
        </tr>

        <tr>
          <td>
            <Field
              component={Checkbox}
              id={`${prefix}-hadWindow`}
              name={`${prefix}.hadWindow`}
              label={t(
                'pages.damageReports.damageReportForm.damageFields.damagePicker.hadWindow'
              )}
            />
          </td>
        </tr>

        {values.hadWindow && (
          <tr>
            <td colSpan={3}>
              <Field
                component={InputField}
                id={`${prefix}-window`}
                name={`${prefix}.window`}
                label={t(
                  'pages.damageReports.damageReportForm.damageFields.damagePicker.windowPart'
                )}
              />
            </td>
          </tr>
        )}

        <tr>
          <td>
            <Field
              component={Checkbox}
              id={`${prefix}-hadOther`}
              name={`${prefix}.hadOther`}
              label={t(
                'pages.damageReports.damageReportForm.damageFields.damagePicker.hadOther'
              )}
            />
          </td>
        </tr>

        {values.hadOther && (
          <tr>
            <td colSpan={3}>
              <Field
                component={InputField}
                id={`${prefix}-other`}
                name={`${prefix}.other`}
                label={t(
                  'pages.damageReports.damageReportForm.damageFields.damagePicker.damageWhat'
                )}
              />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  )
}
